import React, { FC, useMemo } from "react";
import { Item, ItemProps } from ".";
import useAppTranslation from "hooks/useAppTranslation";

interface TextareaProps extends ItemProps {
    value?: string;
    onChange?: (value?: string) => void;
    placeholder?: string;
    rows?: number;
}
const Textarea: FC<TextareaProps> = ({ value, onChange, col, error, label, placeholder, required, rows, itemClassName, helper }) => {

    const { t } = useAppTranslation();
    const inputClassName = useMemo(() => {
        let className = `@app-form-textarea w-full border px-4 py-2 rounded focus:outline-none focus:border-blue-500`;
        if (Boolean(error)) {
            className += " border-red-500 focus:border-red-500 focus:ring-red-500";
        }
        return className;
    }, [error])
    return <Item col={col} label={label} required={required} error={error} itemClassName={itemClassName} helper={helper}>
        <textarea
            value={value || ""}
            onChange={e => onChange && onChange(e.currentTarget.value)}
            className={inputClassName}
            placeholder={placeholder ? placeholder : (React.isValidElement(label) ? '' : `${t("enter", { ns: "common" })} ${String(label)}...`)}
            rows={rows}
        />
    </Item >
}
export default Textarea;